import { render, staticRenderFns } from "./examinationPassed.vue?vue&type=template&id=ca4246be&scoped=true"
import script from "./examinationPassed.vue?vue&type=script&lang=js"
export * from "./examinationPassed.vue?vue&type=script&lang=js"
import style0 from "./examinationPassed.vue?vue&type=style&index=0&id=ca4246be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4246be",
  null
  
)

export default component.exports